export class WebAppInfo {
  public readonly appVersion = "1.5.24 (6)";

}
